
// Standardized content template based on successful course patterns
export const STANDARD_CONTENT_TEMPLATE = {
  // Module introduction with clear learning objectives
  moduleIntroduction: `
# {MODULE_TITLE}

## Learning Objectives
By the end of this module, you will be able to:
- {OBJECTIVE_1}
- {OBJECTIVE_2}
- {OBJECTIVE_3}
- {OBJECTIVE_4}

## Prerequisites
- {PREREQUISITE_1}
- {PREREQUISITE_2}

## Module Overview
{MODULE_OVERVIEW_DESCRIPTION}

**Estimated Time:** {ESTIMATED_TIME}
**Difficulty Level:** {DIFFICULTY_LEVEL}

---
`,

  // Core content structure with practical examples
  coreContentStructure: `
## Key Concepts

### {CONCEPT_1_TITLE}
{CONCEPT_1_EXPLANATION}

#### Why This Matters
{CONCEPT_1_IMPORTANCE}

#### Real-World Application
{CONCEPT_1_REAL_WORLD_EXAMPLE}

### {CONCEPT_2_TITLE}
{CONCEPT_2_EXPLANATION}

#### Best Practices
- {BEST_PRACTICE_1}
- {BEST_PRACTICE_2}
- {BEST_PRACTICE_3}

### {CONCEPT_3_TITLE}
{CONCEPT_3_EXPLANATION}

---
`,

  // Practical examples section
  practicalExamples: `
## Hands-On Examples

### Example 1: {EXAMPLE_1_TITLE}
{EXAMPLE_1_DESCRIPTION}

\`\`\`{LANGUAGE}
{EXAMPLE_1_CODE}
\`\`\`

**Explanation:** {EXAMPLE_1_EXPLANATION}

### Example 2: {EXAMPLE_2_TITLE}
{EXAMPLE_2_DESCRIPTION}

\`\`\`{LANGUAGE}
{EXAMPLE_2_CODE}
\`\`\`

**Key Points:**
- {KEY_POINT_1}
- {KEY_POINT_2}

---
`,

  // Industry context and applications
  industryContext: `
## Industry Applications

### How Professionals Use This
{INDUSTRY_USAGE_DESCRIPTION}

### Popular Tools and Technologies
- **{TOOL_1}**: {TOOL_1_DESCRIPTION}
- **{TOOL_2}**: {TOOL_2_DESCRIPTION}
- **{TOOL_3}**: {TOOL_3_DESCRIPTION}

### Career Relevance
{CAREER_RELEVANCE_DESCRIPTION}

---
`,

  // Module summary and next steps
  moduleSummary: `
## Key Takeaways

✅ **Essential Concepts:**
- {TAKEAWAY_1}
- {TAKEAWAY_2}
- {TAKEAWAY_3}

⚠️ **Common Pitfalls to Avoid:**
- {PITFALL_1}
- {PITFALL_2}

🚀 **Next Steps:**
- {NEXT_STEP_1}
- {NEXT_STEP_2}

## Prepare for Practice
Now that you understand the concepts, it's time to apply them in the Practice tab. You'll work through hands-on exercises that reinforce what you've learned.

---
`
};

// Content quality standards
export const CONTENT_QUALITY_STANDARDS = {
  minWordCount: 800,
  maxWordCount: 2000,
  requiredSections: [
    'Learning Objectives',
    'Prerequisites',
    'Module Overview',
    'Key Concepts',
    'Hands-On Examples',
    'Industry Applications',
    'Key Takeaways'
  ],
  codeExampleCount: { min: 2, max: 5 },
  learningObjectiveCount: { min: 3, max: 6 }
};

// Template variables for different course types
export const COURSE_TYPE_VARIABLES = {
  aws: {
    language: 'bash',
    toolPrefix: 'AWS',
    contextFocus: 'cloud architecture and services'
  },
  java: {
    language: 'java',
    toolPrefix: 'Java',
    contextFocus: 'enterprise application development'
  },
  dotnet: {
    language: 'csharp',
    toolPrefix: '.NET',
    contextFocus: 'Microsoft technology stack'
  },
  ai: {
    language: 'python',
    toolPrefix: 'AI/ML',
    contextFocus: 'artificial intelligence and machine learning'
  },
  gcp: {
    language: 'bash',
    toolPrefix: 'Google Cloud',
    contextFocus: 'Google Cloud Platform services'
  }
};
